import { CustomerWithContacts } from "@/database/schema";
import { ConfirmRestore } from "@/shared/confirmRestore/ConfirmRestore";
import { Row, Table } from "@tanstack/react-table";
import { Undo2 } from "lucide-react";
import { useState } from "react";
import { ArchivedCustomersTableMeta } from "./customersArchive";


interface DataTableRowActionsProps<TData> {
    row: Row<CustomerWithContacts>
    table: Table<TData>
}

export function CustomersArchiveTableRowActions<TData>({
    row,
    table
}: DataTableRowActionsProps<TData>) {
    const { restoreCustomer } = table.options.meta as ArchivedCustomersTableMeta;
    const [confirmRestore, setConfirmRestore] = useState(false);

    return (
        <div className="row-actions" onClick={(e) => e.stopPropagation()}>
            <div className="row-actions__container">
                <button className="row-actions__trigger-button" onClick={() => {
                    setConfirmRestore(true);
                }}>
                    <Undo2 width={18} height={18} />
                </button>
            </div>
            {confirmRestore && <div className="overlay">
                <ConfirmRestore
                    type="Customer"
                    id={row.original.name.toString()}
                    onClose={() => { setConfirmRestore(false); }}
                    onRestore={async () => { await restoreCustomer(row.original.id) }}
                />
            </div>}
        </div>
    )
}